// extracted by mini-css-extract-plugin
export default {"back":"style_back__WeNdt","black":"style_black__S3IHo"};